import { render } from "./TradeAccount.vue?vue&type=template&id=7ab1ab7c"
import script from "./TradeAccount.vue?vue&type=script&lang=js"
export * from "./TradeAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__